import { type ClassValue, clsx } from 'clsx';
import { twMerge } from 'tailwind-merge';

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

/** Duração em segundos (como vem de `lessons.duration`) para "29 min" ou "1h 05min". */
export function duracaoLegivel(segundos: number): string {
  const minutos = Math.max(1, Math.round(segundos / 60));
  if (minutos < 60) return `${minutos} min`;
  const h = Math.floor(minutos / 60);
  const m = minutos % 60;
  return m ? `${h}h ${String(m).padStart(2, '0')}min` : `${h}h`;
}

/** Inline SVG placeholder for courses (dark bg + DevClub green text). */
export const COURSE_PLACEHOLDER = `data:image/svg+xml,${encodeURIComponent(
  '<svg xmlns="http://www.w3.org/2000/svg" width="400" height="225" viewBox="0 0 400 225"><rect width="400" height="225" fill="#0A0A0B"/><text x="50%" y="50%" text-anchor="middle" dy=".3em" fill="#A3E635" font-family="system-ui,sans-serif" font-size="28" font-weight="600" opacity="0.7">Curso</text></svg>',
)}`;
